import httpClient from '../utils/httpClient';

const API = '/irpf';

export const getActiveIrpfConfig = async (year, month) => {
  const y = Number(year);
  const m = Number(month);
  return httpClient.get(`${API}/config/active/${y}/${m}`);
};

export const getAllIrpfConfigs = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.year != null) params.append('year', String(filters.year));
  if (filters.month != null) params.append('month', String(filters.month));
  if (filters.isActive != null) params.append('isActive', String(filters.isActive));

  const query = params.toString();
  const url = query ? `${API}/configs?${query}` : `${API}/configs`;
  return httpClient.get(url);
};

export const getIrpfConfigById = async (configId) => {
  return httpClient.get(`${API}/config/${configId}`);
};

export const createIrpfConfig = async (dto) => {
  return httpClient.post(`${API}/config`, dto);
};

export const updateIrpfConfig = async (configId, dto) => {
  return httpClient.put(`${API}/config/${configId}`, dto);
};

export const deleteIrpfConfig = async (configId) => {
  return httpClient.delete(`${API}/config/${configId}`);
};

